var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"brand-logo d-flex align-center",attrs:{"to":"/"}},[_c('v-img',{staticClass:"me-3 ",attrs:{"src":_vm.appLogo,"width":"100px","alt":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }